"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function UnifiedExtensibleFirmwareGreyOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "#6C757D",
    clipPath: "url(#prefix__unified-extensible-firmware-grey-outline__clip0_19423_5352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.987 11.749H1.282C.575 11.749 0 11.15 0 10.419V3.513c0-.733.575-1.33 1.282-1.33h13.412c.706 0 1.286.597 1.286 1.33v2.83a.6.6 0 11-1.199 0v-2.83c0-.072-.048-.128-.087-.128H1.282c-.04 0-.084.056-.084.128v6.904c0 .072.044.129.084.129h4.705a.6.6 0 01.599.6.6.6 0 01-.6.602z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.352 13.98a.6.6 0 01-.599-.6v-2.185a.6.6 0 111.198 0v2.184a.6.6 0 01-.599.601zM5.136 13.98a.6.6 0 01-.599-.6v-2.185a.6.6 0 111.198 0v2.184a.6.6 0 01-.599.601zM2.249 3.386a.6.6 0 01-.6-.601V.6a.6.6 0 111.199 0v2.184a.6.6 0 01-.6.6zM5.032 3.386a.6.6 0 01-.599-.601V.6a.6.6 0 111.198 0v2.184a.6.6 0 01-.599.6zM7.816 3.386a.6.6 0 01-.599-.601V.6a.6.6 0 111.198 0v2.184a.6.6 0 01-.599.6zM10.6 3.386a.6.6 0 01-.6-.601V.6a.6.6 0 111.199 0v2.184a.6.6 0 01-.6.6zM13.403 3.386a.6.6 0 01-.599-.601V.6a.6.6 0 111.199 0v2.184a.6.6 0 01-.6.6zM11.243 6.848h1.014c.504.196.623.377.627.934 0 .16 0 .328.02.484a.75.75 0 001.083.55c.16-.085.315-.181.475-.273.403-.237.799-.144 1.046.252.132.213.26.43.38.645.211.377.12.77-.24 1.01-.152.1-.315.184-.467.28a.786.786 0 000 1.351c.12.076.244.14.367.212.352.209.524.557.396.95-.096.289-.268.557-.424.825-.235.405-.65.505-1.058.273-.152-.088-.304-.18-.455-.26a.746.746 0 00-1.103.556c-.028.193-.012.393-.02.59-.012.452-.315.76-.77.773-.236.004-.472.004-.707 0-.472-.008-.78-.32-.787-.793 0-.205.008-.41-.02-.61a.75.75 0 00-1.07-.572c-.176.084-.348.176-.524.264-.395.204-.77.108-1.01-.277-.132-.212-.256-.428-.38-.645-.211-.376-.12-.769.244-1.01.148-.096.304-.18.451-.268.532-.316.536-1.014.004-1.326-.12-.072-.247-.14-.367-.213-.42-.252-.547-.729-.304-1.158.108-.192.224-.384.34-.577.235-.388.619-.493 1.03-.288.168.084.336.172.503.256a.754.754 0 001.087-.573c.02-.14.016-.284.016-.424 0-.557.124-.738.627-.934l-.004-.004zm1.653 4.58c0-.641-.507-1.158-1.138-1.158-.639 0-1.158.505-1.158 1.138a1.15 1.15 0 102.296.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.742 8.587c.04.172.1.337.18.489a2.347 2.347 0 00-.168-.008c-.072 0-.14 0-.208.008.084-.152.152-.317.196-.493M9.246 9.965c.188.06.383.093.583.097a2.44 2.44 0 00-.208.356 2.116 2.116 0 00-.375-.453zm4.892.072c-.107.113-.2.237-.275.37a2.316 2.316 0 00-.176-.305c.152 0 .304-.024.451-.065zm-.263 2.385c.104.172.232.328.383.464a1.874 1.874 0 00-.595-.1c.08-.112.152-.236.212-.364zm-4.25.004c.052.108.112.216.18.316a1.847 1.847 0 00-.491.076c.12-.12.227-.252.311-.392zm2.32 1.342a2.043 2.043 0 00-.195.493 2.089 2.089 0 00-.184-.493c.06.004.116.008.176.008.068 0 .136 0 .2-.008m.307-6.92h-1.014c-.503.196-.623.377-.627.934 0 .14 0 .284-.016.424a.748.748 0 01-.743.653.781.781 0 01-.343-.08c-.168-.084-.336-.172-.504-.256a.899.899 0 00-.4-.104c-.25 0-.474.132-.63.388-.116.189-.232.381-.34.577-.243.43-.115.906.304 1.158.12.073.248.14.367.213.528.316.528 1.01-.004 1.326-.151.088-.307.172-.451.269-.363.24-.455.633-.244 1.01.124.216.248.432.38.645.16.252.375.38.619.38.124 0 .26-.036.395-.104.172-.088.348-.18.523-.264a.745.745 0 011.07.573c.029.2.017.404.02.609.009.476.316.785.788.793h.367c.112 0 .228 0 .34-.004.45-.012.754-.32.77-.773.004-.197-.008-.393.02-.59a.74.74 0 01.74-.649c.119 0 .247.028.363.093.155.08.303.176.455.26a.853.853 0 00.427.124c.252 0 .48-.136.631-.396.156-.269.328-.533.424-.826.128-.393-.044-.737-.396-.95-.12-.072-.247-.14-.367-.212a.785.785 0 010-1.35c.156-.096.32-.18.467-.28.36-.241.456-.634.24-1.01-.124-.217-.248-.433-.38-.646-.16-.252-.375-.38-.615-.38a.873.873 0 00-.431.128c-.156.092-.312.188-.475.272a.759.759 0 01-.34.085.753.753 0 01-.743-.634c-.024-.16-.02-.324-.02-.484 0-.553-.123-.738-.627-.934v.012zm-.507 5.726a1.15 1.15 0 01-1.146-1.166c0-.63.52-1.138 1.154-1.138.631 0 1.138.52 1.138 1.158 0 .633-.515 1.146-1.15 1.146h.004z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__unified-extensible-firmware-grey-outline__clip0_19423_5352"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

UnifiedExtensibleFirmwareGreyOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
UnifiedExtensibleFirmwareGreyOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = UnifiedExtensibleFirmwareGreyOutline;
exports["default"] = _default;